const LIMITS = {
  IMAGES: 2,
  ARTICLE_CARD_TITLE: 51,
};

export default LIMITS;
